interface Props {
  [key: string]: any
}

export default function ShieldPersonIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 22 22" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M18.3447 11.924C18.3447 16.5102 15.1344 18.8033 11.3187 20.1333C11.1189 20.201 10.9019 20.1977 10.7042 20.1241C6.87932 18.8033 3.669 16.5102 3.669 11.924V5.5034C3.669 5.26013 3.76564 5.02683 3.93765 4.85482C4.10967 4.6828 4.34297 4.58617 4.58624 4.58617C6.4207 4.58617 8.71378 3.48549 10.3098 2.09129C10.5041 1.92527 10.7513 1.83406 11.0069 1.83406C11.2624 1.83406 11.5096 1.92527 11.704 2.09129C13.3091 3.49466 15.593 4.58617 17.4275 4.58617C17.6708 4.58617 17.9041 4.6828 18.0761 4.85482C18.2481 5.02683 18.3447 5.26013 18.3447 5.5034V11.924Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.83447"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M5.84818 17.3454C6.23958 16.2926 6.94374 15.3848 7.86612 14.7438C8.78849 14.1028 9.8849 13.7594 11.0081 13.7597C12.1313 13.76 13.2276 14.104 14.1496 14.7455C15.0716 15.3869 15.7753 16.2952 16.1661 17.3482"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.83447"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M11.0069 13.7583C13.0331 13.7583 14.6758 12.1157 14.6758 10.0894C14.6758 8.06308 13.0331 6.42045 11.0069 6.42045C8.98056 6.42045 7.33792 8.06308 7.33792 10.0894C7.33792 12.1157 8.98056 13.7583 11.0069 13.7583Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.83447"
      />
    </svg>
  )
}
